export const TEXT_SHARE_COOWNERSHIP_CODE = (code) => {
  return `Bonjour à tous,

L'outil Trustymo est utilisé sur votre résidence pour faciliter la communication entre prestataires, gestionnaires et copropriétaires.
Pour rester informé des actualités de votre immeuble, veuillez télécharger l'application sur votre téléphone mobile.
Créez votre compte et renseignez le code immeuble ${code}

📲 App Store : https://apps.apple.com/fr/app/trustymo/id6468989373  
📲 Play Store : https://play.google.com/store/apps/details?id=com.trustymo&hl=fr

Les 3 principales fonctionnalités:
- sondage interactif pour faciliter la prise de décision en impliquant les locataires rapidement ou planifier des visites.
- un affichage virtuel en temps réel pour une information rapide 
- un calendrier numérique pour une gestion centralisée des prestataires sous contrat afin d'assurer un meilleur suivi avec tracabilite des interventions et transparence auprès de tous.

Nous restons à votre disposition.

Cordialement`
}


export const TEXT_SHARE_COOWNERSHIP_CODE_PROVIDERS = (coownershipName, code) => {
  return `Bonjour
  
La copropriété ${coownershipName} à mis en place l'application TRUSTYMO qui permet de fluidifier la communication entre prestataires, copropriétaires et gestionnaires. 

En tant que prestataire, nous vous invitons a créer un compte pour valoriser vos interventions.

Pour cela il faudra vous inscrire sur le lien ci-dessous avec le code prestataire ${code}

https://app.trustymo.com

Ensuite, vous pourrez vous connecter ou rajouter des copropriétés depuis votre espace. 

Nous restons bien évidemment à votre disposition`
}


export const TEXT_SHARE_BILLBOARD = (code) => {
  return `Bonjour,

Un nouvel affichage a été réalisé sur trustymo par votre gestionnaire.
Pour le consulter veuillez télécharger l'application TRUSTYMO sur votre mobile.

📲 App Store : https://apps.apple.com/fr/app/trustymo/id6468989373  
📲 Play Store : https://play.google.com/store/apps/details?id=com.trustymo&hl=fr

Trustymo vous permettra de rester informé des futures actualités de votre immeuble en facilitant la communication entre prestataires, gestionnaires et copropriétaires. 

Créez votre compte et renseignez le code propriétaire ${code} pour recevoir les notifications des futures actualités.

Cordialement`
}

export const TEXT_SHARE_SURVEY = (code) => {
  return `Bonjour,

Un nouveau sondage a été créé sur trustymo par votre gestionnaire.
Pour le consulter veuillez télécharger l'application TRUSTYMO sur votre mobile.

📲 App Store : https://apps.apple.com/fr/app/trustymo/id6468989373  
📲 Play Store : https://play.google.com/store/apps/details?id=com.trustymo&hl=fr

Trustymo vous permettra de rester informé des futures actualités de votre immeuble en facilitant la communication entre prestataires, gestionnaires et copropriétaires. 

Créez votre compte et renseignez le code propriétaire ${code} pour recevoir les notifications des futures actualités.

Cordialement`
}


export const TEXT_SHARE_EVENT = (code) => {
  return `Bonjour,

Un nouvel événement a été réalisé sur trustymo par votre gestionnaire.
Pour le consulter veuillez télécharger l'application TRUSTYMO sur votre mobile.

📲 App Store : https://apps.apple.com/fr/app/trustymo/id6468989373  
📲 Play Store : https://play.google.com/store/apps/details?id=com.trustymo&hl=fr

Trustymo vous permettra de rester informé des futures actualités de votre immeuble en facilitant la communication entre prestataires, gestionnaires et copropriétaires. 

Créez votre compte et renseignez le code propriétaire ${code} pour recevoir les notifications des futures actualités.

Cordialement`
}

export const TEXT_SHARE_COOWNERSHIP_ADMIN = (coownershipName, codeOwner, codeTenant, codeProvider, codeRentalManager) => {
  return `Bonjour,

Suite à la création de la copropriété ${coownershipName} sur l'outil TRUSTYMO, vous trouverez ci-dessous les codes immeuble à transmettre aux différentes parties prenante:

Code propriétaire : ${codeOwner} 
Code locataire : ${codeTenant}
Code prestataire : ${codeProvider}
Code gestionnaire : ${codeRentalManager != "" ? codeRentalManager : "code non renseigné"}

Nous restons à votre disposition pour toutes demandes d'informations complémentaires.

Cordialement

L'équipe de TRUSTYMO`
}